import React, { Component } from 'react'
import PropTypes from 'prop-types'
import withFadeInUpAnimation from '../../hocs/withFadeInUpAnimation'

export class RegisterWithTokenCard extends Component {
  render() {
    const { children } = this.props
    return (
      <div id="instoken">
        <div className="card shadow text-center">
          <div className="card-body">
            <h3 className="color-body">Institutional Plan</h3>
            <div style={{background: '#ececec', margin: '0 -20px', paddingTop: 30, height: 153}}>
              <h1 className="color-blue m-0" style={{fontWeight: 800, fontSize: 35}}>Contact</h1>
              <p className="text-center" style={{padding: '0 20px', fontSize: 14, marginBottom: 0, height: 40}}>
                <a href="https://resources.steppingblocks.com/hello-school-meet-your-digital-career-counselor" target="_blank" rel="noopener noreferrer">
                  Get Steppingblocks for your school!
                </a>
              </p>
              <p style={{fontSize: 14}}>*Multi-tier admin control</p>
            </div>
            <div style={{marginTop: 80}}>
              <h5 className="color-header">Register with a Token</h5>
              {children}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

RegisterWithTokenCard.propTypes = {
  children: PropTypes.element.isRequired,
}

export default withFadeInUpAnimation(RegisterWithTokenCard)



// WEBPACK FOOTER //
// ./src/components/ui/cards/RegisterWithTokenCard.js